import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import es from "./locales/es.json";
import store from "./redux/Store";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

store.subscribe(() => {
  const state = store.getState();
  const lang = state.language?.lang || "en";

  if (i18n.language !== lang) {
    i18n.changeLanguage(lang);
  }
});

export default i18n;
